// components/StopMarker.jsx
import React from 'react';
import { CircleMarker } from 'react-leaflet';

function StopMarker({ stop, onClick }) {
    if (!stop.stopLat || !stop.stopLon) return null;

    return (
      <CircleMarker
        center={[stop.stopLat, stop.stopLon]}
        radius={7}
        pathOptions={{
          color: '#FFFFFF',
          weight: 1.5,
          fillColor: '#0891B2',
          fillOpacity: 0.85,
        }}
        eventHandlers={{
          click: () => onClick(stop),
        }}
      />
    );
}

export default StopMarker;